import { render, staticRenderFns } from "./Product-JYL.vue?vue&type=template&id=1ed6c403&scoped=true"
import script from "./Product-JYL.vue?vue&type=script&lang=js"
export * from "./Product-JYL.vue?vue&type=script&lang=js"
import style0 from "./Product-JYL.vue?vue&type=style&index=0&id=1ed6c403&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed6c403",
  null
  
)

export default component.exports